import React, { createRef, useContext, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../helpers/components/KTSVG'
import { GET_ALL_TEAMS_AND_USERS, GET_TEAMS } from '../../graphql/query'
import { useQuery } from '@apollo/client'
import UserContext from '../../context/UserContext'
import { createInitials } from '../../utils/functions/createInitials'
import ChatContext from '../../context/ChatContext'

interface IProps {
  disabledIndexes: number[]
  handleOpenChat: (user: any) => void
  UnreadCount: any
  refetchUnreadCount: any
}

const TeamPanel: React.FC<IProps> = ({
  disabledIndexes,
  handleOpenChat,
  UnreadCount,
  refetchUnreadCount
}) => {
  const { currentUser } = useContext(UserContext)
  const chatWindowDropdownMenuRef = useRef<any[]>([])

  const [teamName, setTeamName] = useState<string>('')
  const [memberName, setMemberName] = useState<string>('')

  const { state } = useContext(ChatContext)

  const {
    data: teamData,
    error: teamError,
    loading: teamLoading
  } = useQuery(GET_TEAMS, {
    context: {
      headers: {
        'access-control-allow-methods': 'Human-hand-off'
      }
    }
  })

  const { data, error, loading, refetch } = useQuery(GET_ALL_TEAMS_AND_USERS, {
    variables: {
      input: {
        teamName,
        memberName
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Human-hand-off'
      }
    }
  })

  const [expandedTeams, setExpandedTeams] = useState<{
    [key: string]: boolean
  }>({})

  useEffect(() => {
    console.log(state, 'hdhadikadhadkhadkhk')

    refetchUnreadCount()
  }, [state])

  const toggleTeam = (teamId: string) => {
    setExpandedTeams((prev) => ({
      ...prev,
      [teamId]: !prev[teamId]
    }))
  }

  const unreadCountMap: { [key: number]: number } = {}
  UnreadCount?.getTeamsWithUnreadCounts?.forEach((team: any) => {
    team?.members?.forEach((member: any) => {
      unreadCountMap[member.id] = member.unreadCount
    })
  })

  const handleTeamChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setTeamName(event.target.value)
    refetch({ input: { teamName: event.target.value, memberName } })
    refetchUnreadCount()
  }

  const handleMemberSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMemberName(event.target.value)
    refetch({ input: { teamName, memberName: event.target.value } })
    refetchUnreadCount()
  }

  chatWindowDropdownMenuRef.current =
    data?.getAllTeamsAndUsers?.data?.flatMap(
      (team: any) =>
        team?.users?.map(
          (user: any, index: number) => chatWindowDropdownMenuRef.current[index] ?? createRef()
        ) || []
    ) || []

  if (loading || teamLoading) return <div>Loading...</div>
  if (error || teamError) return <div>Error loading data</div>

  return (
    <div className='card p-2' style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 2px 8px 0px' }}>
      <div className='flex-column'>
        <div id='kt_chat_contacts_header'>
          <form className='w-100 position-relative'>
            <div className='search-bar d-flex'>
              <div>
                <select
                  className='form-select form-select-solid'
                  aria-label='Select Team'
                  value={teamName}
                  onChange={handleTeamChange}
                  style={{ borderRadius: '0rem' }}
                >
                  <option value=''>All Teams</option>
                  {teamData?.getTeams.map((team: any) => (
                    <option key={team.id} value={team.name}>
                      {team.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <form className='w-100 position-relative' autoComplete='off'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y'
                  />
                  <input
                    type='text'
                    className='form-control form-control-solid px-15'
                    name='search'
                    placeholder='Search Member'
                    value={memberName}
                    onChange={handleMemberSearch}
                    style={{
                      borderLeft: '1px solid #e1e3e4',
                      borderRadius: '0rem'
                    }}
                    autoFocus
                  />
                </form>
              </div>
            </div>
          </form>
        </div>

        <div id='kt_chat_contacts_body'>
          <div className='card-body scroll-y p-0'>
            <div className='mh-700px'>
              {data?.getAllTeamsAndUsers?.data?.map((team: any) => {
                const isExpanded = expandedTeams[team.id] || false
                return (
                  <div key={team.id} className='mb-3 border rounded bg-white shadow-sm'>
                    <div
                      className='d-flex justify-content-between align-items-center px-4 py-3 cursor-pointer bg-light'
                      onClick={() => toggleTeam(team.id)}
                    >
                      <span className='fw-bold fs-6 text-primary'>{team.name}</span>
                      <span className='fs-4 text-muted'>
                        <i
                          className={`bi ${isExpanded ? 'bi-chevron-down' : 'bi-chevron-right'}`}
                        ></i>
                      </span>
                    </div>

                    <div
                      style={{
                        maxHeight: isExpanded ? '500px' : '0px',
                        overflow: 'scroll',
                        transition: 'max-height 0.3s ease-in-out'
                      }}
                    >
                      <div className='p-3'>
                        {team?.users?.length > 0 ? (
                          team?.users?.map((user: any) => {
                            if (parseInt(currentUser.id) === user.id) return null

                            const { label, state } = createInitials(user.name)
                            const unread = unreadCountMap[user?.id] || 0

                            return (
                              <div
                                key={user.id}
                                className='d-flex justify-content-between align-items-center py-3 px-3 border-bottom'
                              >
                                <div
                                  className='d-flex align-items-center'
                                  onClick={() => handleOpenChat(user)}
                                >
                                  <div className='symbol ps-1 symbol-40px symbol-circle me-3'>
                                    <span
                                      className={`symbol-label bg-light-${state} text-${state} fs-6 fw-bolder`}
                                    >
                                      {label}
                                    </span>
                                  </div>
                                  <div className='ms-1 d-flex flex-column'>
                                    <div
                                      className='fs-7 fw-bold text-gray-900 text-hover-primary mb-1'
                                      role='button'
                                    >
                                      {user.name || 'N/A'}
                                    </div>
                                    <div className='text-muted fw-bold fs-8'>
                                      {user.email || 'N/A'}
                                    </div>
                                  </div>
                                </div>

                                {unread > 0 && (
                                  <div
                                    className='badge badge-light-danger fs-7 fw-bold d-flex align-items-center justify-content-center'
                                    style={{
                                      minWidth: '24px',
                                      height: '24px',
                                      padding: '0 8px',
                                      borderRadius: '999px',
                                      fontSize: '0.75rem',
                                      lineHeight: '1',
                                      boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                                    }}
                                    title={`${unread} unread message${unread > 1 ? 's' : ''}`}
                                  >
                                    {unread > 99 ? '99+' : unread}
                                  </div>
                                )}
                              </div>
                            )
                          })
                        ) : (
                          <div className='text-center text-muted py-3'>No agents available</div>
                        )}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeamPanel
